module.exports = __webpack_public_path__ + "img/nature.612f9363.png";